import { OAuthClientDetails } from './types';

export const OAUTH_CLIENT_EXPIRY = 60 * 1000;

export const PAGE_QUERY_PARAM = 'page';

export const MAX_OAUTH_CLIENT_NAME_CHAR_COUNT = 255;

// How many OAuth clients are shown per page
export const OAUTH_CLIENTS_PAGE_SIZE = 20;

export const OAUTH_CLIENT_DETAILS_EMPTY: OAuthClientDetails = {
  // Fields generated by Bitbucket
  client_id: '',
  secret: '',
  grant_types: [],
  authorization_link: '',
  // Required Fields
  name: '',
  callbacks: [],
  scopes: [],
  // Optional Fields
  contact_link: null,
  description: '',
  eula_link: null,
  is_private: false,
  privacy_policy_link: null,
};
